import React from 'react';
import {Tab} from '../../Library';
import Button from '../../../../Button';
import styles from './TabSwitcher.module.scss';
import {useHistory, useLocation} from 'react-router';
import pageTitles from '../../../../../../../pageTitles';

export default function TabSwitcher() {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className={styles.TabsWrapper}>
      {Object.values(Tab).map((tab) => (
        <div className={styles.ButtonWrapper}>
          <Button
            onClick={() => history.push(tab)}
            background={location.pathname === tab}
          >
            {pageTitles[tab] || 'Library'}
          </Button>
        </div>
      ))}
    </div>
  );
}
